<template>
    <div class="v-atlas-raumplanung-main">
        <TabsGroup class="x-auto-expand">
            <!--#region Data table tab-->
            <Tab label="Datentabelle" tab-key="list" class="v-atlas-raumplanung-main__features-list">

                <RaumplanungFeaturesList v-model:order-by="orderBy" v-model:order-dir="orderDir"
                    :map-module="props.mapModule" :data="props.mapModule.reactiveData.responseData as any" />

            </Tab>
            <!--#endregion Data table tab-->


            <!--#region Settings tab -->
            <Tab label="Optionen" tab-key="settings" class="v-atlas-raumplanung-main__settings">

                <RequestOptionsPanel v-model:settings="requestSettings" :options="geojsonData?.requestOptions"
                    :view-stack-controller="props.viewStackController" />

                <p>
                    {{ props.mapModule.reactiveData.responseData?.style.description }}
                </p>

                <div data-help="raumplanung-data-download">
                    <h3>Datensatz herunterladen</h3>
                    <p>

                        <a class="c-button" :href="downloadExcelUrl" download="data.xlsx">
                            Excel
                        </a>
                        <a class="c-button" :href="downloadGeoJsonUrl" download="data.geojson">
                            GeoJSON
                        </a>
                    </p>
                </div>

            </Tab>
            <!--#endregion Settings tab -->
        </TabsGroup>



        <LoadingIndicatorOverlay v-if="isLoadingDelayed" />
    </div>
</template>

<script setup lang="ts">
//#region 3rd party imports
import { LoadingIndicatorOverlay, useDelayedBoolean, ViewStackController, Tab, TabsGroup, ColorGradientConfig, SvgColorGradient } from "gertrud";
import { computed, ref, watch } from "vue";
import { RaumplanungGeoJsonResponse } from "atlas-shared";

import { registerHelpText } from 'gertrud'



//#endregion 3rd party imports

//#region Local imports

import { useMessages } from "@/composables/useMessages";
import { RaumplanungMapModule } from "@/mapModules/raumplanung/RaumplanungMapModule";

import RaumplanungFeaturesList from "./RaumplanungFeaturesList.vue";
import RequestOptionsPanel from "../../components/requestOptions/RequestOptionsPanel.vue";

//#endregion Local imports


const props = withDefaults(defineProps<{
    mapModule: RaumplanungMapModule
    viewStackController: ViewStackController
}>(), {
});


registerHelpText("raumplanung-data-download", "Per Klick auf einen dieser Buttons kann der aktuell dargestelle Datensatz im jeweiligen Dateiformat heruntergeladen werden.")

registerHelpText("raumplanung-main-select-indicator", "Hier kann ein Indikator ausgewählt werden.")

const messages = useMessages();

const orderBy = ref("name")
const orderDir = ref("asc")

//#region Computed dataset download link URLs
function buildDownloadUrl(ext: 'geojson' | 'xlsx'): string {
    const s = {
        ...props.mapModule.reactiveData.requestSettings,
        orderBy: orderBy.value,
        orderDir: orderDir.value
    };
    return `${props.mapModule.moduleConfig.serviceBaseUrl}/data.${ext}?settings=${encodeURIComponent(JSON.stringify(s))}`;
}

const downloadGeoJsonUrl = computed(() => buildDownloadUrl('geojson'));

const downloadExcelUrl = computed(() => buildDownloadUrl('xlsx'));
//#endregion Computed dataset download link URLs


const isLoading = computed(() => props.mapModule.reactiveData.isLoading)

const isLoadingDelayed = useDelayedBoolean(isLoading, 250, 0);



const geojsonData = computed(() => {
    return props.mapModule.reactiveData.responseData
})

const requestSettings = computed({
    get: () => props.mapModule.reactiveData.requestSettings,
    set: (val) => {
        props.mapModule.reactiveData.requestSettings = val
    }
})


watch(() => props.mapModule.reactiveData.responseData, (newVal: RaumplanungGeoJsonResponse | null) => {

    if (!newVal) {
        return;
    }

    if (newVal.messages) {
        for (const m of newVal.messages) {
            messages.addMessage(m);
        }
    }
},
);
</script>
